var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { SCOREBOARD_RESET, SCOREBOARD_SET_CATEGORY, SCOREBOARD_SET_ROUND, SCOREBOARD_SET_TEAM, SCOREBOARD_SET_ATHLETE, SCOREBOARD_SET_ATHLETE_SCORE, SCOREBOARD_SET_ATHLETE_SCORE_ROUTE, } from './actions';
var initialState = {
    categoryId: undefined,
    roundId: undefined,
    teamId: undefined,
    athleteId: undefined,
    athleteScoreId: undefined,
};
export var scoreboardReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case SCOREBOARD_RESET:
            return initialState;
        case SCOREBOARD_SET_CATEGORY:
            return __assign({}, state, { categoryId: action.payload.categoryId });
        case SCOREBOARD_SET_ROUND:
            return __assign({}, state, { roundId: action.payload.roundId });
        case SCOREBOARD_SET_TEAM:
            return __assign({}, state, { teamId: action.payload.teamId });
        case SCOREBOARD_SET_ATHLETE:
            return __assign({}, state, { athleteId: action.payload.athleteId });
        case SCOREBOARD_SET_ATHLETE_SCORE:
            return __assign({}, state, { athleteScoreId: action.payload.athleteScoreId });
        case SCOREBOARD_SET_ATHLETE_SCORE_ROUTE:
            return __assign({}, state, { athleteScoreRouteId: action.payload.athleteScoreRouteId });
        default:
            return state;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/imports/components/Scoreboard/reducers/reducer.ts
// module id = 427
// module chunks = 0